import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isFunction, get } from 'lodash';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  makeStyles,
  withStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  const surfaceConfig = theme.palette.surface[theme.palette.type];
  const containedConfig = surfaceConfig.button.contained;
  const outlinedConfig = surfaceConfig.button.outlined;
  const buttonConfig = theme.typography.button;

  return {
    root: {
      display: 'flex',
      flex: '0 0 auto',
      alignItems: 'center',
      justifyContent: 'left',
    },
    btnContained: {
      marginLeft: 0,
      paddingLeft: buttonConfig.paddingLeft,
      paddingRight: buttonConfig.paddingRight,
      borderRadius: buttonConfig.borderRadius,
      height: buttonConfig.height,
      backgroundColor: containedConfig.bgColor,
      '&:hover': {
        backgroundColor: containedConfig.hoveredBgColor,
      },
      '&:focus': {
        border: containedConfig.border,
        borderColor: containedConfig.borderColor,
        backgroundColor: containedConfig.bgColor,
      },
    },
    btnOutlined: {
      border: outlinedConfig.border,
      color: outlinedConfig.color,
      marginRight: theme.spacing(1),
      backgroundColor: outlinedConfig.bgColor,
      '&:hover': {
        border: outlinedConfig.hoveredBorder,
        backgroundColor: outlinedConfig.hoveredBgColor,
      },
      '&:focus': {
        border: outlinedConfig.selectedBorder,
        backgroundColor: outlinedConfig.selectedBgColor,
      },
    },
  };
});

const CommentsDialog = ({
  open, message, onClose, onConfirm, required,
}) => {
  const { title, content } = message;
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState(false);

  const classes = useStyles();
  const handleInputChange = (event) => {
    setError(false);
    const value = get(event, ['target', 'value'], '');
    if (value.length <= 500) {
      setInputValue(value);
    }
  };

  const handleOnConfirm = (value) => {
    if (required && !value) {
      setError(true);
    } else {
      setError(false);
      onConfirm(value);
    }
  };
  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={onClose}
      >
        <DialogTitle id="alert-dialog-title">
          {title}
          <span />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Comment"
            fullWidth
            multiline
            error={error}
            required={required}
            rows="4"
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            className={classes.btnOutlined}
          >
            Cancel
          </Button>
          {isFunction(onConfirm) && (
            <Button
              onClick={() => handleOnConfirm(inputValue)}
              variant="contained"
              color="primary"
              className={classes.btnContained}
            >
              Save
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

CommentsDialog.defaultProps = {
  message: {
    title: 'Comment',
    content: 'Please input your comments.',
  },
  required: false,
  onClose: () => { },
  onConfirm: () => { },
};

CommentsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  required: PropTypes.bool,
  message: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default CommentsDialog;
